module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "poem",
    attrs: {
      "id": "poemParent"
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.poemTransitionName,
      "mode": "out-in"
    },
    on: {
      "after-leave": _vm.afterLeave
    }
  }, [_c('article', {
    key: _vm.nr,
    staticClass: "poem__main",
    class: {
      select: _vm.$store.state.selectEnabled
    },
    style: ({
      fontSize: _vm.fontSizeREM
    }),
    attrs: {
      "id": "poem"
    }
  }, [(_vm.selectedPoem) ? [_c('h1', {
    staticClass: "poem__title"
  }, [_vm._v("\n          " + _vm._s(_vm.selectedPoem.t) + "\n        ")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.selectedPoem.d) ? _c('p', {
    staticClass: "poem__desc"
  }, [_vm._v(_vm._s(_vm.selectedPoem.d))]) : _vm._e(), _vm._v(" "), _c('pre', {
    staticClass: "poem__blocks",
    style: ({
      columnRuleColor: _vm.theme.rule
    })
  }, [_vm._v(_vm._s(_vm.selectedPoem.s))])] : _vm._e(), _vm._v(" "), _c('loading', {
    staticClass: "loading",
    attrs: {
      "color": _vm.theme.accent
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "poem__author"
  }, [_vm._v("—Traian Dorz")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "poem__url",
    attrs: {
      "id": "currentURL"
    }
  }, [_vm._v(_vm._s(_vm.currentURL))])], 2)]), _vm._v(" "), (_vm.$store.state.folderListDownloaded) ? _c('div', {
    staticClass: "button-prev",
    on: {
      "click": _vm.prevPoem
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "fill": _vm.theme.icon2,
      "height": "24",
      "width": "24"
    }
  }, [_c('use', {
    attrs: {
      "href": "#iconPrev"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.folderListDownloaded) ? _c('div', {
    staticClass: "button-next",
    on: {
      "click": _vm.nextPoem
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "fill": _vm.theme.icon2,
      "height": "24",
      "width": "24"
    }
  }, [_c('use', {
    attrs: {
      "href": "#iconNext"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "poem__share",
    style: ({
      backgroundColor: _vm.theme.background
    })
  }, [_c('svg', {
    staticClass: "icon icon-copy",
    attrs: {
      "data-clipboard-target": "#poem",
      "id": "btnCopy",
      "fill": _vm.theme.icon2,
      "height": "24",
      "viewBox": "0 0 24 24",
      "width": "24"
    },
    on: {
      "click": _vm.enableSelect
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"
    }
  })]), _vm._v(" "), (_vm.navigatorHasShare) ? _c('svg', {
    staticClass: "icon icon-share-toggle",
    attrs: {
      "fill": _vm.theme.icon2,
      "height": "24",
      "viewBox": "0 0 24 24",
      "width": "24"
    },
    on: {
      "click": _vm.toggleShareMenu
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "pop"
    }
  }, [(_vm.$store.state.copyConfirmShown) ? _c('div', {
    staticClass: "copy-confirm",
    style: ({
      backgroundColor: _vm.theme.confirm,
      color: _vm.theme.confirm2
    })
  }, [_c('span', [_vm._v("Copiat")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "poem__zoom",
    style: ({
      backgroundColor: _vm.theme.background
    })
  }, [_c('transition', {
    attrs: {
      "name": "slide-zoom-3"
    }
  }, [(_vm.zoomMenuOpen) ? _c('svg', {
    staticClass: "icon icon-zoom",
    attrs: {
      "fill": _vm.theme.icon2,
      "height": "24",
      "viewBox": "0 0 24 24",
      "width": "24"
    },
    on: {
      "click": _vm.zoomReset
    }
  }, [_c('path', {
    attrs: {
      "d": "M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-zoom-2"
    }
  }, [(_vm.zoomMenuOpen) ? _c('svg', {
    staticClass: "icon icon-zoom",
    attrs: {
      "fill": _vm.theme.icon2,
      "height": "24",
      "viewBox": "0 0 24 24",
      "width": "24"
    },
    on: {
      "click": _vm.zoomOut
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0V0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7z"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-zoom-1"
    }
  }, [(_vm.zoomMenuOpen) ? _c('svg', {
    staticClass: "icon icon-zoom",
    attrs: {
      "fill": _vm.theme.icon2,
      "height": "24",
      "viewBox": "0 0 24 24",
      "width": "24"
    },
    on: {
      "click": _vm.zoomIn
    }
  }, [_c('path', {
    attrs: {
      "d": "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0V0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('svg', {
    staticClass: "icon icon-zoom-toggle",
    class: {
      toggled: _vm.zoomMenuOpen
    },
    attrs: {
      "fill": _vm.zoomMenuOpen ? _vm.theme.accent : _vm.theme.icon2,
      "height": "24",
      "viewBox": "0 0 24 24",
      "width": "24"
    },
    on: {
      "click": _vm.toggleZoomMenu
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M9 4v3h5v12h3V7h5V4H9zm-6 8h3v7h3v-7h3V9H3v3z"
    }
  })])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-182097a6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Poem.vue
// module id = 128
// module chunks = 1